import React from "react";

type CenterColumnType = {
    children?: any;
    wrapClasses?: Array<string>;
    classes?: Array<string>;
}
const CenterColumn = ({ children, wrapClasses, classes }: CenterColumnType) => {

    return (
        <div className={`max-w-full w-full ${wrapClasses && wrapClasses.join(' ')}`}>
            <div className={`ml-auto mr-auto max-w-full w-full lg:w-1000 xl:w-1200 ${classes && classes.join(' ')}`}>
                {children}
            </div>
        </div>
    )

}

export default CenterColumn;